var oldHeight;
var topOffset = 20;

function startsWith(str, pattern) {
	return (str.match('^' + pattern) == pattern);
}

function endsWith(str, pattern) {
	return (str.match(pattern + '$') == pattern);
}

function navTab(tab) {
	// Handle tab system
	var av_t = new YAHOO.util.Element('av-b-t');
	var ac_t = new YAHOO.util.Element('ac-b-t');
	var h_t = new YAHOO.util.Element('h-b-t');

	if (av_t.hasClass('tab-active')) {
		av_t.removeClass('tab-active');
		av_t.addClass('tab-notactive');
	}

	if (ac_t.hasClass('tab-active')) {
		ac_t.removeClass('tab-active');
		ac_t.addClass('tab-notactive');
	}

	if (h_t.hasClass('tab-active')) {
		h_t.removeClass('tab-active');
		h_t.addClass('tab-notactive');
	}

	if (tab == 'available-bonuses') {
		av_t.removeClass('tab-notactive');
		av_t.addClass('tab-active');
	}

	if (tab == 'active-bonuses') {
		ac_t.removeClass('tab-notactive');
		ac_t.addClass('tab-active');
	}

	if (tab == 'bonus-history') {
		h_t.removeClass('tab-notactive');
		h_t.addClass('tab-active');
	}

	// Handle Content
	var av_b = new YAHOO.util.Element('available-bonuses');
	var ac_b = new YAHOO.util.Element('active-bonuses');
	var h_b = new YAHOO.util.Element('bonus-history');

	av_b.setStyle('display', (tab == 'available-bonuses') ? 'block' : 'none');
	ac_b.setStyle('display', (tab == 'active-bonuses') ? 'block' : 'none');
	h_b.setStyle('display', (tab == 'bonus-history') ? 'block' : 'none');

}
function posY(obj) {
	var curtop = 0;
	if (obj.offsetParent) {
		while (1) {
			curtop += obj.offsetTop;
			if (!obj.offsetParent) {
				break;
			}
			obj = obj.offsetParent;
		}
	}
	else if (obj.y) {
		curtop += obj.y;
	}
	return curtop;
}

// TODO: temporary workaround for below horribleness to work. Real fix, write real toggle functionality and don't use iframes
function resizeBonusesAfterToggle() {
	'use strict';
	var $leftcolumn = $('#leftcolumn');
	var height = $leftcolumn.height() + $leftcolumn.offset().top;
	window.top.reSizeBodyFrame(height);
}

function showAvaBDetail(id) {
	'use strict';

	oldHeight = document.body.parentNode.scrollHeight + 'px';
	$('#ava-bonus-extended-' + id).show();
	$('#avb-detshow-' + id).hide();
	$('#avb-dethide-' + id).show();

	resizeBonusesAfterToggle();

	return false;
}

function hideAvaBDetail(id) {
	'use strict';
	$('#ava-bonus-extended-' + id).hide();
	$('#avb-detshow-' + id).show();
	$('#avb-dethide-' + id).hide();
	reSize();
	var f = window.top.document.getElementById('bodyframe');
	f.style.height = oldHeight;
	var o = document.getElementById('ava-b-' + id);
	top.window.scroll(0, ((posY(o) - topOffset) < 0) ? 0 : (posY(o) - topOffset));

	resizeBonusesAfterToggle();

	return false;
}

function showActBDetail(id) {
	'use strict';
	oldHeight = document.body.parentNode.scrollHeight + 'px';

	$('#act-bonus-extended-' + id).show();
	$('#act-detshow-' + id).hide();
	$('#act-dethide-' + id).show();

	resizeBonusesAfterToggle();

	return false;
}

function hideActBDetail(id) {
	'use strict';
	$('#act-bonus-extended-' + id).hide();
	$('#act-detshow-' + id).show();
	$('#act-dethide-' + id).hide();

	reSize();
	var f = window.top.document.getElementById('bodyframe');
	f.style.height = oldHeight;
	var o = document.getElementById('act-b-' + id);
	top.window.scroll(0, ((posY(o) - topOffset) < 0) ? 0 : (posY(o) - topOffset));

	resizeBonusesAfterToggle();

	return false;
}

function expandHist(id) {
	var detail = 'unfolded-item-' + id;
	var header = 'history-bonus-' + id;

	// Get all row elements on the page
	var tableRows = document.getElementsByTagName('tr');

	// Loop through subjects
	for ( var i = 0; i < tableRows.length; i++) {
		var s_tag = tableRows[i].id;

		if (startsWith(s_tag, 'history-bonus-')) {
			var tag = new YAHOO.util.Element(s_tag);

			if (s_tag == header) {
				if (tag.hasClass('notselected')) {
					tag.replaceClass('notselected', 'selected');
				}
			} else {
				if (tag.hasClass('selected')) {
					tag.replaceClass('selected', 'notselected');
				}
			}
		}
	}
	// Loop through messages
	for ( var j = 0; j < tableRows.length; j++) {
		var m_tag = tableRows[j].id;
		if (startsWith(m_tag, 'unfolded-item-')) {
			var tag = new YAHOO.util.Element(m_tag);
			if (m_tag == detail) {
				if (tag.getStyle('display') == displayStatus) {
					tag.setStyle('display', 'none');
				} else {
					tag.setStyle('display', displayStatus);
				}
			} else {
				tag.setStyle('display', 'none');
			}
		}
	}
	reSize();
	return false;
}

function toggleThis(th, id) {
	var el = document.getElementById('p_' + id);
	var fp = document.getElementById('fp_' + id);
	var sp = document.getElementById('sp_' + id);

	th.innerHTML = (th.innerHTML.indexOf('-') > 0) ? ('<span>+</span>') : ('<span>-</span>');

	if (th.innerHTML.indexOf('-') > 0) {
		el.innerHTML = fp.value;
	} else {
		el.innerHTML = sp.value;
	}

	resizeBonusesAfterToggle();
}

function getUserBarFreeBal() {
	return $('#cnt-player-bar').find('#unlocked-balance').text();
}

function openExistingFundsForm(bid, in_b_e_f_head, in_b_e_f_bread, in_b_e_f_img, in_b_e_f_max, in_b_e_f_min, in_b_e_f_prc, bonusTypeId) {
	document.getElementById('b_e_f_head').innerHTML = in_b_e_f_head;
	document.getElementById('b_e_f_bread').innerHTML = in_b_e_f_bread;
	document.getElementById('b_e_f_img').src = in_b_e_f_img;
	document.getElementById('b_e_f_max').innerHTML = in_b_e_f_max;
	document.getElementById('b_e_f_min').innerHTML = in_b_e_f_min;
	document.getElementById('b_e_f_prc').innerHTML = in_b_e_f_prc;
	document.getElementById('b_e_f_free_bal').innerHTML = top.getUserBarFreeBal();

	var form = document.getElementById('redeemExistForm');
	form.elements[0].value = bid;

	bonusChecks(openExistingFundsFormAfterVerificationTest, bonusTypeId);
	return false;
}

var openExistingFundsFormAfterVerificationTest = {
	execute : function() {
		var x = document.getElementById('bonusredeemform');
		window.top.showModalPanel(redeemExistingHeader, x.innerHTML, null, '500px', 'bodyframe', true, true);
		return false;
	}
};

var redSuccess = function(o) {
	// Parsing JSON strings can throw a SyntaxError exception, so we wrap the call
	// in a try catch block
	try {
		var formResponse = YAHOO.lang.JSON.parse(o.responseText);
		if (formResponse['RESULT'] != 'OK') {
			if (formResponse[jsonReturnCode] == regStatusLow)
				askToOpenBasicFullRegForm();
			else
				window.top.showInfoMessage(formResponse['ERROR_HEADER'], formResponse['ERROR'], formResponse['BUTTON_TEXT']);
		} else {
			window.top.showInfoMessage(redeemFreeHeader, formResponse['TEXT'], formResponse['BUTTON_TEXT'], false, null, 'bodyframe', redeemFreePanelHeader,
					null, null, true);
		}
	} catch (e) {
		window.top.showSystemError('System error', 'An unexpected system error occured in redSuccess', 'OK');
	}
};

var redFailure = function(o) {
	window.top.showSystemError('System error', 'An unexpected system error occured in redFailure', 'OK');
};

var redCallback = {
	success : redSuccess,
	failure : redFailure,
	cache : false
};

var bonusId;
var registrationStatusJSON = {
	success : function(o) {
		var params = YAHOO.lang.JSON.parse(o.responseText);

		regStatus = params.REG_STATUS;

		if (regStatus === 'real') {
			YAHOO.util.Connect.asyncRequest('GET', '/pp?flow=65&PARAM_BONUS_ID=' + bonusId, redCallback);
		} else {
			window.top.registration.openBasicToFull();
		}

	},
	failure : function(o) {

	},
	cache : false,
	timeout : 5000
};

function checkVerificationsForBonus(bid, bonusTypeId) {
	bonusId = bid;
	bonusChecks(gotoDepositPageAfterVerificationTest, bonusTypeId);
	return false;
}

var gotoDepositPageAfterVerificationTest = {
	execute : function() {
		top.scrollTo(0, 0);
		window.top.location.href = myPagesDepositUrl + '&ATTR_BONUS_ID=' + bonusId;
		return false;
	}
};

function redeemFreeMoneyBonus(bid, bonusTypeId) {
	bonusId = bid;
	bonusChecks(redeemFreeMoneyBonusAfterVerificationTest, bonusTypeId);
}

var redeemFreeMoneyBonusAfterVerificationTest = {
	execute : function() {
		YAHOO.util.Connect.asyncRequest('POST', domainUrl, registrationStatusJSON, 'flow=getRegStatus');
		return false;
	}
};

function cancelActiveBonus(bid, inHeader, inImg, inCAmount, inPOAmount) {
	var form = document.getElementById('bcancelconfform');
	form.elements[0].value = bid;
	document.getElementById('b_c_c_img').src = inImg;
	document.getElementById('b_c_c_header').innerHTML = inHeader;
	document.getElementById('b_c_amount').innerHTML = inCAmount;
	var x = document.getElementById('bonuscancelconfirm');

	var form2 = document.getElementById('bcobcancelconfform');
	form2.elements[0].value = bid;
	document.getElementById('b_c_c_ob_img').src = inImg;
	document.getElementById('b_c_c_ob_header').innerHTML = inHeader;
	var y = document.getElementById('bonuscancelopenbetconfirm');

	window.top.showCBPanel(panelHeaderBonusCancel, x.innerHTML, y.innerHTML);
	return false;
}

function askToOpenBasicFullRegForm() {
	var x = document.getElementById('openbasicfullregform');
	window.top.showModalPanel(headerCompleteRegistration, x.innerHTML, null, null, 'bodyframe', true, true);
}

var tempBId = null;
var pokerRegStatusResp = {
	success : function(o) {
		var params = YAHOO.lang.JSON.parse(o.responseText);
		if (params['RESULT'] == 'NOK' || params['RESULT'] == '0') {
			var x = document.getElementById('notPokerRegged');
			window.top.showModalPanel(panelHeaderNotPokerRegged, x.innerHTML, null, null, 'bodyframe', true, true);
			tempBId = null;
		} else {
			top.scrollTo(0, 0);
			window.top.location.href = myPagesDepositUrl + tempBId;
		}
	},

	failure : function(o) {
		var x = document.getElementById('notPokerRegged');
		window.top.showModalPanel(panelHeaderNotPokerRegged, x.innerHTML, null, null, 'bodyframe', true, true);
		tempBId = null;
	},
	cache : false
};

function openNotPokerReggedForm(inBonusId, bonusTypeId) {
	tempBId = inBonusId;
	bonusChecks(openNotPokerReggedFormAfterVerificationTest, bonusTypeId);
	return false;
}

var openNotPokerReggedFormAfterVerificationTest = {
	execute : function() {
		YAHOO.util.Connect.asyncRequest('POST', '/pp', pokerRegStatusResp, 'flow=303');
		return false;
	}

};

function hideBonus( bonusId) {
	document.getElementById('ava-b-' + bonusId).className = 'li-container-hidden';
	hideAvaBDetail(bonusId);
	var totalheight = document.body.clientHeight;
	window.top.reSizeBodyFrame(totalheight);
}

function showBonus(bonusId) {
	document.getElementById('ava-b-' + bonusId).className = 'li-container';
	showAvaBDetail(bonusId);
	var totalheight = document.body.clientHeight;
	window.top.reSizeBodyFrame(totalheight);
}
;
define("legacy/bonus/bonus", function(){});

